import isPromise from "is-promise";
import { isFSA } from "flux-standard-action";
import { Actions } from "../modules/Actions";

const promiseMiddleware = ({ dispatch }) => {
  return (next) => (action) => {
    // Guard against undefined/null actions
    if (!action) {
      return next(action);
    }

    if (!isFSA(action)) {
      return isPromise(action)
        ? action
            .then((result) => {
              // Only dispatch if result is a valid action object
              if (result && typeof result === "object" && result.type) {
                return dispatch(result);
              }
              // If result is undefined/null, don't dispatch anything
              return result;
            })
            .catch((error) => {
              // Handle promise rejection gracefully
              console.error("Promise middleware: Promise rejected", error);
              return Promise.reject(error);
            })
        : next(action);
    }

    const isLoadingAction = action.meta && action.meta.loading;
    if (isPromise(action.payload)) {
      if (isLoadingAction) {
        dispatch(Actions.common.loadingStarted(action));
      }
      return action.payload
        .then((result) => {
          dispatch({ ...action, payload: result });
          if (isLoadingAction) {
            dispatch(Actions.common.loadingFinished(action));
          }
        })
        .catch((error) => {
          // Ensure action exists before spreading
          if (action) {
            dispatch({ ...action, payload: error, error: true });
            if (isLoadingAction) {
              dispatch(Actions.common.loadingFinished(action));
            }
          }
          return Promise.reject(error);
        });
    } else {
      return next(action);
    }
  };
};
export default promiseMiddleware;
